import { idSchema, stringSchema, objectSchema } from '@/schemas'

export const templateSchema = objectSchema({
  title: stringSchema,
  type: stringSchema,
  content: stringSchema,
  header_id: idSchema.nullable().optional(),
  footer_id: idSchema.nullable().optional(),
  parent_id: idSchema.nullable().optional(),
})
